@if (isOpen()) {
  <div
    class="fixed inset-0 z-9999 w-full flex items-center justify-center p-4 bg-gray-900/60 backdrop-blur-sm"
    role="dialog"
    aria-modal="true"
    [attr.aria-labelledby]="'info-dialog-title'"
  >
    <div
      class="relative w-full max-w-2xl overflow-hidden rounded-3xl border border-gray-200 bg-white p-8 shadow-2xl dark:border-gray-700 dark:bg-gray-800 flex flex-col items-center text-center"
    >
      <!-- Success icon -->
      <div
        class="flex h-20 w-20 items-center justify-center rounded-full bg-green-50 text-green-500 dark:bg-green-500/10 dark:text-green-400 mb-6"
      >
        <svg class="h-10 w-10" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M5 13l4 4L19 7"
          />
        </svg>
      </div>

      <h3 id="info-dialog-title" class="text-2xl font-bold text-gray-900 dark:text-white mb-3">
        {{ title() }}
      </h3>

      <p class="text-base text-gray-600 dark:text-gray-300 mb-8">
        {{ message() }}
      </p>

      <button
        type="button"
        (click)="closed.emit()"
        class="w-full h-12 cursor-pointer rounded-2xl bg-blue-600 px-6 text-base font-semibold text-white shadow-sm transition-all hover:bg-blue-700 hover:shadow-md focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-blue-600"
      >
        {{ buttonLabel() }}
      </button>
    </div>
  </div>
}
